import getLocal from '@/app/utils/getLocal';
import classNames from 'classnames';
import React, { useState } from 'react';
import EfTooltip from '../ef-tooltip';
import './index.scss';
import { langText } from './langText';

interface EfCouponProps {
    /**
     * 优惠码
     */
    value: string;
    /**
     * 优惠券-左侧文案
     */
    couponText: string;
    /**
     * 优惠券-提示语
     */
    couponTips?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 复制回调
     */
    callback?: any;
}

/**
 * 维护:谢保林
 *
 * 优惠码
 */
const EfCoupon: React.FC<EfCouponProps> = ({ value, couponText, couponTips, className, callback }) => {
    const { locale } = getLocal();
    const textA = langText[locale] || langText['us'];
    const prefixCls = `ef-coupon`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const [showSuccessTips, setShowSuccessTips] = useState(false);

    // 点击复制
    const copyHandle = () => {
        try {
            navigator.clipboard.writeText(value);
        } catch (err: any) {}
        setShowSuccessTips(true);
        setTimeout(() => {
            setShowSuccessTips(false);
        }, 2000);
    };

    return (
        <div className={classes}>
            <span className={`${prefixCls}-off`}>
                <span className={`${prefixCls}-text`}>{couponText}</span>
                {couponTips && (
                    <span className={`${prefixCls}-exclamation`}>
                        !<EfTooltip>{couponTips}</EfTooltip>
                    </span>
                )}
            </span>
            <span className={`${prefixCls}-split`}></span>
            <span className={`${prefixCls}-copy${showSuccessTips ? ` ${prefixCls}-show-tips` : ''}`} onClick={copyHandle}>
                {textA.copy_text}
                <EfTooltip>{textA.success_tips}</EfTooltip>
            </span>
        </div>
    );
};

export default EfCoupon;
